module.exports = __webpack_public_path__ + "static/media/error.716c3b53.svg";